import axios from "axios";

export const apiNode = axios.create({
  baseURL: process.env.REACT_APP_NODE_HOST,
});

export const apiNodeSimulador = axios.create({
  baseURL: `${process.env.REACT_APP_NODE_HOST}/simulator/`,
});

// Interceptor para atualizar o JWT em cada requisição
apiNodeSimulador.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("jwt");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
